module.exports = __webpack_public_path__ + "img/ch46.d1d7f8b9.jpg";